import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes, { any } from 'prop-types';

import Popup from '../../../../../components/Popup';
import InvitedPlayer from '../InvitedPlayer';

import { declinePartnerInvitations } from '../../../../../actions/event-profile-actions';
import { registrationStateTypeIds } from '../../../../../utils/eventConstants';

import styles from './declineInvitationPopup.scss';

const DeclineInvitationPopup = (props) => {
    const {
        event,
        declineDivisionData,
        toggleSplashBallLoader,
        closePopup,
        isSideBarSplashLoading,
    } = props;

    const {
        division,
    } = declineDivisionData;

    const dispatch = useDispatch();

    const invitedByPlayerName = useMemo(() => {
        const invitedByPlayer = division?.player2;

        return `${invitedByPlayer.firstName} ${invitedByPlayer.lastName}`;
    }, [division]);

    const onCancelDecline = () => {
        closePopup();
    };

    const onDeclineConfirmationClick = async () => {
        toggleSplashBallLoader();
        await dispatch(declinePartnerInvitations(event.id, [{ ...division }]), false);
        toggleSplashBallLoader();
        closePopup();
    };

    const showAlternatePreRegCopy = event.registrationStateId === registrationStateTypeIds.PRE_REGISTRATION && event.hasEligiblePlayersList;

    return (
        <Popup
            className="popup-md"
            config={{
                scrollable: false,
                showCloseIcon: false,
                style: {
                    maxHeight: '80vh',
                },
            }}
            closeOnClickOutside={false}
        >
            <div className={`${styles.invitationPopup}`}>
                <div className="popup-section mb16">
                    <h5 className={styles.title} data-testid="modal.decline-invitation.title">
                        Are you sure you want to {showAlternatePreRegCopy ? 'decline this invite' : 'remove this partner'}?
                    </h5>
                </div>
                <div className="popup-section">
                    <div className={`${styles.description} mb8`} data-testid="modal.decline-invitation.description">
                        {!showAlternatePreRegCopy && `Removing ${invitedByPlayerName} will send them a message telling them you are declining their invitation. You can then choose another partner or register without a partner. `}
                    </div>
                </div>
                <div className="popup-section">
                    <div className={styles.playersWrapper}>
                        <InvitedPlayer
                            player={division.player2}
                            className={styles.player}
                            sportTypeId={event?.sportTypeId}
                            data-testid="modal.decline-invitation.invited-player"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className={`col-md-6 mt16`}>
                        <button
                            type="button"
                            className="btn btn-default btn-default text-uppercase btn-block"
                            onClick={onCancelDecline}
                            disabled={isSideBarSplashLoading}
                            data-testid="modal.decline-invitation.cancel-btn"
                        >
                            Cancel
                        </button>
                    </div>
                    <div className={`col-md-6 mt16`}>
                        <button
                            type="button"
                            className="btn btn-primary btn-default text-uppercase btn-block"
                            onClick={onDeclineConfirmationClick}
                            disabled={isSideBarSplashLoading}
                            data-testid="modal.decline-invitation.decline-btn"
                        >
                            Remove & Decline
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

DeclineInvitationPopup.propTypes = {
    event: PropTypes.objectOf(any).isRequired,
    declineDivisionData: PropTypes.objectOf(any).isRequired,
    closePopup: PropTypes.func.isRequired,
    toggleSplashBallLoader: PropTypes.func.isRequired,
    isSideBarSplashLoading: PropTypes.bool,
};

DeclineInvitationPopup.defaultProps = {
    isSideBarSplashLoading: false,
};

export default DeclineInvitationPopup;
